import Ajax from 'js/utils/ajax/ajax.js';
import { ApiCustomerSystem } from 'src/interfaces/interfaces.generated';

export const editCustomerSystem = (customersystem: ApiCustomerSystem): Promise<ApiCustomerSystem> =>
  Ajax.patch(`/customersystems/v1/${customersystem.customerSystemId}`, customersystem);
